import { IFeeTable, IVatTable } from '../ITaxesTable';
import { VatCalculatingError } from '../Errors/VatCalculatingError';
import { TaxLoaderError } from '../Errors/TaxLoaderError';
import { ITaxLoader } from './ITaxLoader';
import { HubJsonRpcRequest } from '../../../../api/HubJsonRpcRequest';
import { HubApiMethods } from '../../../../constants/HubApiMethods';
import { CurrentUser } from '../../user/currentUser';
import { container } from '../../../../utils/container/container';
import { FeatureFlagsLoader } from '@scorewarrior/rubens_web_lib';
import { ServiceIds } from '../../../../utils/container/service-ids';
import { FlagNames } from '../../../../utils/feature-flags/flag-names';
import { getHubApi } from '../../accountServiceApi/getAccountServiceApi';

export class TaxLoader implements ITaxLoader {
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor() {}

    public async getFee(): Promise<IFeeTable | VatCalculatingError> {
        try {
            const currentUser = CurrentUser.getInstance();
            const ffLoader = container.get<FeatureFlagsLoader>(ServiceIds.FEATURE_FLAG_LOADER);
            const isHubApiEnabled = ffLoader.get(FlagNames.SITE_HUB_API_ENABLED)?.isOn();

            let jsonRpcResponse;

            if (!isHubApiEnabled) {
                jsonRpcResponse = await HubJsonRpcRequest.makeRequest<IFeeTable, {suid: string, token: string}>(
                    HubApiMethods.GET_FEE,
                    {
                        suid: currentUser.getSuid(),
                        token: window.app.config.user_auth_token
                    },
                    window.app.deviceIdentifier
                );
                console.log(jsonRpcResponse);

                if ('error' in jsonRpcResponse) {
                    return new TaxLoaderError(`FEE: ${jsonRpcResponse.error.message}`);
                }
            } else {
                const hubApi = getHubApi();
                jsonRpcResponse = await hubApi.getFee(window.app.deviceIdentifier, {
                    suid: currentUser.getSuid(),
                    token: window.app.config.user_auth_token
                });
            }

            console.log('FEE From API Service', jsonRpcResponse);
            return jsonRpcResponse;
        } catch (exception) {
            return new TaxLoaderError(`Exception on getting fee rate: ${exception.message}`);
        }
    }


    public async getVat(): Promise<IVatTable | VatCalculatingError> {
        try {
            const currentUser = CurrentUser.getInstance();
            const ffLoader = container.get<FeatureFlagsLoader>(ServiceIds.FEATURE_FLAG_LOADER);
            const isHubApiEnabled = ffLoader.get(FlagNames.SITE_HUB_API_ENABLED)?.isOn();

            let jsonRpcResponse;

            if (!isHubApiEnabled) {
                jsonRpcResponse = await HubJsonRpcRequest.makeRequest<IVatTable, {suid: string, token: string}>(
                    HubApiMethods.GET_VAT,
                    {
                        suid: currentUser.getSuid(),
                        token: window.app.config.user_auth_token
                    },
                    window.app.deviceIdentifier
                );

                if ('error' in jsonRpcResponse) {
                    return new TaxLoaderError(`Error on getting VAT from API: ${jsonRpcResponse.error.message}`);
                }
            } else {
                const hubApi = getHubApi();
                jsonRpcResponse = await hubApi.getVat(window.app.deviceIdentifier, {
                    suid: currentUser.getSuid(),
                    token: window.app.config.user_auth_token
                });
            }

            console.log('VAT From API Service', jsonRpcResponse);
            return jsonRpcResponse;
        } catch (exception) {
            return new TaxLoaderError(`Exception on getting VAT rate: ${exception.message}`);
        }
    }
}
